import AgyleButton from '../ui/buttons/agyleButton';
import {FormLabel, Paper} from '@mui/material';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {setSnackbar} from '../../store/reducers/globals';
import MiniFormDialog from './miniFormDialog';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
    },
    statusDL: {
        maxHeight: 300,
        overflowY: 'auto',
        padding: 10,
    },
}));

const ERROR_STATUS = [
    {code: '400', description: 'Bad Request'},
    {code: '401', description: 'Unauthorized'},
    {code: '402', description: 'Payment Required'},
    {code: '403', description: 'Forbidden'},
    {code: '404', description: 'Not Found'},
    {code: '405', description: 'Method Not Allowed'},
    {code: '406', description: 'Not Acceptable'},
    {code: '407', description: 'Proxy Authentication Required'},
    {code: '408', description: 'Request Timeout'},
    {code: '409', description: 'Conflict'},
    {code: '410', description: 'Gone'},
    {code: '411', description: 'Length Required'},
    {code: '412', description: 'Precondition Failed'},
    {code: '413', description: 'Payload Too Large'},
    {code: '414', description: 'URI Too Long'},
    {code: '415', description: 'Unsupported Media Type'},
    {code: '416', description: 'Range Not Satisfiable'},
    {code: '417', description: 'Expectation Failed'},
    {code: '418', description: 'I\'m a Teapot'},
    {code: '421', description: 'Misdirected Request'},
    {code: '422', description: 'Unprocessable Entity'},
    {code: '423', description: 'Locked'},
    {code: '424', description: 'Failed Dependency'},
    {code: '425', description: 'Too Early'},
    {code: '426', description: 'Upgrade Required'},
    {code: '428', description: 'Precondition Required'},
    {code: '429', description: 'Too Many Requests'},
    {code: '431', description: 'Request Header Fields Too Large'},
    {code: '451', description: 'Unavailable For Legal Reasons'},
    {code: '500', description: 'Internal Server Error'},
    {code: '501', description: 'Not Implemented'},
    {code: '502', description: 'Bad Gateway'},
    {code: '503', description: 'Service Unavailable'},
    {code: '504', description: 'Gateway Timeout'},
    {code: '505', description: 'HTTP Version Not Supported'},
    {code: '506', description: 'Variant Also Negotiates'},
    {code: '507', description: 'Insufficient Storage'},
    {code: '508', description: 'Loop Detected'},
    {code: '510', description: 'Not Extended'},
    {code: '511', description: 'Network Authentication Required'},
];

const DischargeLetterModal = ({open, onClose, patient}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [toggleError, setToggleError] = useState(false);

    const copyMessage = () => {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(patient?.studies?.dischargeLetter?.sendStatus)
            .then(() => {
                dispatch(setSnackbar({
                    type: 'success',
                    message: 'The discharge letter send status has been copied to the clipboard.',
                }));
            });
    };

    const checkErrorStatus = () => {
        const errorText = patient?.studies?.dischargeLetter?.sendStatus.substring(0, 20);
        let error = 'Other';

        _.forEach(ERROR_STATUS, (str) => {
            if (errorText && errorText.includes(str.code)) {
                error = `[${str.code}] ${str.description}`;
            }
        });
        return error;
    };

    return (
        <MiniFormDialog
            open={open}
            width="md"
            noPadding
            disableSave
            title={t('ED Discharge Letter Error')}
            closeButtonOnHeader
            onClose={onClose}
            buttons={[
                <AgyleButton
                    key="show"
                    variant="contained"
                    color="primary"
                    onClick={() => setToggleError(!toggleError)}
                >
                    {t('Show full description')}
                </AgyleButton>,
                <AgyleButton
                    key="copy"
                    variant="contained"
                    color="primary"
                    onClick={copyMessage}
                >
                    {t('Copy Error message')}
                </AgyleButton>,
            ]}
        >
            <>
                <div className={classes.root}>
                    <FormLabel>
                        {t(`Error status`)}: {checkErrorStatus()}
                    </FormLabel>

                    {toggleError &&
                        <Paper className={clsx(classes.statusDL, 'scroll-normal-white')}>
                            {patient?.studies?.dischargeLetter?.sendStatus}
                        </Paper>
                    }
                </div>
            </>
        </MiniFormDialog>
    );
};

export default DischargeLetterModal;